import { AnalyticsEvent } from '../event'
import { GlobalDataFormatter } from './global-data'
import { GtmProvider } from './gtm/default'
import { KruxProvider } from './krux/default'
import { MParticleProvider } from './mparticle/events/default'
import { PermutiveProvider } from './permutive/default'

export class Default extends AnalyticsEvent {

    /**
     * Handle event
     */
    public handle(event?: Event): void {

        /**
         * Event Handler: create Attributes list and send it to vendors providers
         * @var data will be different for each event, and for each provider
         *
         */
        const dataAttrs = this.getGeneralAttributesList()

        // Get Data Values (// metaProperties data coming from page-data)
        const globalFormatter = new GlobalDataFormatter(this.metaProperties)
        const data: any = {}
        dataAttrs.forEach((attr) => {
            try {
                const attrValue = globalFormatter.lookup(attr, event)
                if(attrValue !== '') {
                    data[attr] = attrValue
                }
            } catch(e) {
                console.error('GlobalDataFormatter error in class Default', e)
            }
        })

        const controlFields = this.getControlFields()

        if(controlFields.mparticle) {
            const mparticle = new MParticleProvider(data, this.type, this.value, this.action, this.element)
            mparticle.setMetaProperties(this.metaProperties)
            mparticle.handle(event)
        }

        if(controlFields.krux) {
            const krux = new KruxProvider(data, this.type, this.value, this.action, this.element)
            krux.setMetaProperties(this.metaProperties)
            krux.handle()
        }
        if(controlFields.gtm) {
            const gtm = new GtmProvider(data, this.type, this.value, this.action, this.element)
            gtm.setMetaProperties(this.metaProperties)
            gtm.handle()
        }
        if(controlFields.permutive) {
            const permutive = new PermutiveProvider(data, this.type, this.value, this.action, this.element)
            permutive.setMetaProperties(this.metaProperties)
            permutive.handle()
        }
    }
}
